import { FlatList, RefreshControl } from 'react-native';
import { ProtocolItem } from 'src/core/types/Protocols';
import React from 'react';
import { UIHelper as uh } from 'src/core';
import ActiveProtocolListItem from './ActiveProtocolListItem';

interface AddProtocolListProps {
  protocols: ProtocolItem[];
  handleEndReached?: () => void;
  onRefresh?: () => void;
  refreshing: boolean;
}

const ActiveProtocolList = ({ protocols, handleEndReached, refreshing, onRefresh }: AddProtocolListProps) => {
  const renderListItem = ({ item }: { item: ProtocolItem }) => {
    return <ActiveProtocolListItem protocol={item} />;
  };
  return (
    <FlatList
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
      style={{ marginVertical: uh.h2DP(8) }}
      onEndReached={handleEndReached}
      renderItem={renderListItem}
      data={protocols}
    />
  );
};

export default ActiveProtocolList;
